<template>
  <div class="home-view internal">
    <section class="list">
      <div class="container" v-if="loaded">
        <h1 class="title-default">Perguntas Frequentes<span></span></h1>

        <ul v-if="!!items.length">
          <li v-for="item in items" :key="item.id">
            <h6><strong>{{ item.pergunta }}</strong></h6>

            <p v-html="item.resposta" />
          </li> <!-- /li -->
        </ul> <!-- /ul -->

        <ul v-else>
          <li class="empty">
            <h2 class="aligncenter">Nenhum item cadastrado.</h2>
          </li>
        </ul>
      </div> <!-- /.container -->
    </section> <!-- /.list -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'faq',

  data () {
    const data = {
      items: [],
      loaded: false
    }

    return data
  }, // data()

  beforeMount () {
    this.loadList()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadList () {
      try {
        const { empreendimentoIdWeb } = this.$store.state.contratoAtual

        const xhr = await PagesService.getFAQ()
        const { empreendimento } = await PagesService.getEmp(empreendimentoIdWeb)

        this.items = xhr.filter(item => {
          if (item.exibirPara === 'TODOS') {
            return true
          }

          const arr = item.exibirPara.split(',')
          if (!isNaN(arr[0])) {
            return arr.includes(`${empreendimentoIdWeb}`)
          } else {
            return arr.includes(`${empreendimento.tipo}`)
          }

          return false
        })

        this.loaded = true
      } catch (e) {
        console.error('Falha ao corrigir FAQ', e)
      }
    } // loadList()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section.list ul
    li
      display: inline-block
      width: 100%

      h6
        font-family: 'Gotham-Bold'
        font-size: 18px
        margin-bottom: 15px

      p
        display: block
        width: 100%

        strong
          font-weight: bold

    @media (max-width: 1024px)
      padding: 20px
</style>
